import { Component } from '@angular/core';

@Component({
  selector: 'app-leaflet-maps-layout',
  templateUrl: './leaflet-maps-layout.html',
})
export class LeafletMapsLayoutComponent {}
